import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8 10.252h4a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1 0-1.5ZM7.254 8a.749.749 0 0 0 .75.75h2a.75.75 0 0 0 0-1.5H8a.743.743 0 0 0-.746.75Zm.68-2.34a.742.742 0 0 0 .53-.22.754.754 0 0 0 0-1.06l-2.92-2.91a.751.751 0 0 0-.38-.21c-.05 0-.1-.01-.15-.01s-.1.01-.15.01a.751.751 0 0 0-.38.21l-2.91 2.91a.75.75 0 0 0 1.06 1.06l1.63-1.63V14a.75.75 0 0 0 1.5 0V3.812L7.4 5.442a.742.742 0 0 0 .534.22ZM14 13.252H8a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5Z';
const draw24px =
  'M9.65,6.67a.77.77,0,0,1-.53.21.74.74,0,0,1-.53-.21L7,5V20a.75.75,0,0,1-1.5,0V5L3.82,6.67A.75.75,0,0,1,2.76,5.6L5.67,2.69a.73.73,0,0,1,.53-.22.72.72,0,0,1,.53.22L9.65,5.6A.77.77,0,0,1,9.65,6.67Zm12,12.39a.76.76,0,0,0-.75-.75h-8a.75.75,0,0,0,0,1.5h8A.76.76,0,0,0,21.68,19.06Zm-2.29-5.53a.76.76,0,0,0-.75-.75H12.93a.75.75,0,0,0,0,1.5h5.71A.76.76,0,0,0,19.39,13.53ZM17.11,8a.76.76,0,0,0-.75-.75H12.93a.75.75,0,0,0,0,1.5h3.43A.76.76,0,0,0,17.11,8Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const SortUpIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'sortUp'),
) as IconWithRender;

SortUpIcon.displayName = 'SortUpIcon';
SortUpIcon.propTypes = Icon.propTypes;
SortUpIcon.renderIcon = (props) => <SortUpIcon {...props} />;
export default SortUpIcon;
